export default __webpack_public_path__ + "static/media/Flexibilty_active.f0e9ea6e.svg";